import { APIProvider, Map, Marker, useMap } from "@vis.gl/react-google-maps";
import { useCallback, useEffect, useState } from "@wordpress/element";

export function StoresGoogleMap({
  markerUrl,
  activeMarkerUrl,
  center,
  zoom,
  onSelect,
  selected,
  list,
}) {
  const [isInitialized, setIsInitialized] = useState(false);
  const map = useMap();

  useEffect(() => {
    if (!map) return;
    if (!isInitialized) {
      setIsInitialized(true);
      return;
    }
    if (!list) return; // Par défaut si aucun center renseigné
    const bounds = new google.maps.LatLngBounds();
    list.forEach(function (store) {
      const latLng = new google.maps.LatLng(store.latLng);
      bounds.extend(latLng);
    });
    map.fitBounds(bounds);
  }, [list, map]);

  return (
    <Map
      style={{ width: "100%", height: "100%" }}
      defaultCenter={center}
      defaultZoom={zoom}
      disableDefaultUI={false}
    >
      {(list || []).map((store) => (
        <Marker
          key={store.id}
          position={store.latLng}
          icon={
            selected && selected.id == store.id && activeMarkerUrl
              ? activeMarkerUrl
              : markerUrl
          }
          onClick={() => onSelect && onSelect(store)}
        />
      ))}
    </Map>
  );
}
